import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

interface GxSecondaryButtonRedProps {
  handleClose: () => void;
  label?: string;
}
const GxSecondaryButtonRed: React.FC<GxSecondaryButtonRedProps> = ({
  handleClose,
  label = "",
}) => {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      onClick={handleClose}
      className="gx-dialog-back-yellowbutton gx-submit-for-approval"
    >
      <span className="gx-h4-eb"> {t(label)}</span>
    </Button>
  );
};

export default GxSecondaryButtonRed;
